import React, { useMemo, useState } from "react";
import { Form } from "semantic-ui-react";
import { useAuth } from "../../../../hooks";
import { addSimulators } from "../../../../api";
import { SimulatorPicker } from "./SimulatorPicker";
import "./ServerForm.scss";

export function AddSimulatorsForm({
  onClose,
  onReload,
  serverId,
  existingIds = [],
}) {
  const { accessToken } = useAuth();

  // Pre-selecciona los ya existentes para que se muestren en modo “Quitar”
  const [selectedIds, setSelectedIds] = useState(
    (existingIds || []).map(String),
  );

  // Set con los ya existentes (para calcular el delta a enviar)
  const existingSet = useMemo(
    () => new Set((existingIds || []).map(String)),
    [existingIds],
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      // Solo enviamos los nuevos: selected - existing
      const toAdd = (selectedIds || []).filter(
        (id) => !existingSet.has(String(id)),
      );

      if (toAdd.length === 0) {
        // No hay nada nuevo que agregar; cerramos de forma silenciosa
        onClose?.();
        return;
      }

      // OJO: pasamos un ARRAY plano de ids
      await addSimulators(accessToken, serverId, toAdd);

      onReload?.();
      onClose?.();
    } catch (err) {
      console.error("[AddSimulatorsForm] addSimulators failed:", err);
    }
  };

  return (
    <Form className="add-simulators-form" onSubmit={onSubmit}>
      <h4>Agregar simuladores</h4>

      <SimulatorPicker
        value={selectedIds}
        onChange={setSelectedIds}
        pageSize={8}
      />

      <Form.Button
        type="submit"
        primary
        fluid
        disabled={
          (selectedIds || []).filter((id) => !existingSet.has(String(id)))
            .length === 0
        }
      >
        Agregar
      </Form.Button>
    </Form>
  );
}
